import { Label } from 'components/atoms';
import { Contract, FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import i18next from 'i18next';
import {
  ITemplatesLightListItem,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import './ContractSideMenuTemplateListWrapper.scss';

interface IContractSideMenuTemplateListWrapperProps {
  templates?: ITemplatesLightListItem[];
  templateType: TEMPLATE_TYPE;
  item: (
    value: ITemplatesLightListItem,
    index: number,
    array: ITemplatesLightListItem[]
  ) => JSX.Element;
}

const ContractSideMenuTemplateListWrapper = ({
  templates,
  templateType,
  item,
}: IContractSideMenuTemplateListWrapperProps) => {
  const { values } = useFormikContractHelpers();

  const getFilteredTemplates = () =>
    templates?.filter(({ title }) =>
      title && values.sideMenu?.customTemplate
        ? `${title}`
            .toLowerCase()
            .trim()
            .includes(
              values.sideMenu.customTemplate.search.toLowerCase().trim()
            )
        : true
    ) ?? [];

  const headerTitle = i18next.t(
    `enum.TEMPLATE_TYPE.${TEMPLATE_TYPE[templateType]}`
  );

  return (
    <Contract.SideMenu.Wrapper
      header={
        <>
          <Label withText title={headerTitle}>
            {headerTitle}
          </Label>
          <span className='w-[44px]' />
        </>
      }>
      <div className='contract-side-menu-templates-content-wrapper'>
        <FormInput.Text
          name='sideMenu.customTemplate.search'
          label='Search'
          placeholder={headerTitle}
        />
        <div className='contract-side-menu-templates-list'>
          {getFilteredTemplates().map(item)}
        </div>
      </div>
    </Contract.SideMenu.Wrapper>
  );
};

export default ContractSideMenuTemplateListWrapper;
